module.exports = __webpack_public_path__ + "img/banner_mobile.68ecc16.svg";